module.exports = __webpack_public_path__ + "static/media/PTManagerWWIDPopulated.aac4d9b8.png";